import { apiFetch } from './client'

export type RemoteOperation = 'OPEN_DOOR' | 'CLOSE_DOOR' | 'GET_DOOR_STATUS' | 'PING'

export interface RemoteCommand {
  id: string
  device_id: string
  operation: RemoteOperation
  status: 'pending' | 'executing' | 'done' | 'failed'
  result: Record<string, unknown> | null
  error: string | null
  resolved_at: string | null
}

export const createRemoteCommand = (deviceId: string, operation: RemoteOperation) =>
  apiFetch<{ command: RemoteCommand }>('/remote-commands', {
    method: 'POST',
    body: JSON.stringify({ deviceId, operation }),
  })

export const getRemoteCommand = (id: string) =>
  apiFetch<{ command: RemoteCommand }>(`/remote-commands/${id}`)

export async function waitForCommand(id: string, timeoutMs = 30_000): Promise<RemoteCommand> {
  const deadline = Date.now() + timeoutMs
  while (Date.now() < deadline) {
    const { command } = await getRemoteCommand(id)
    if (command.status === 'done' || command.status === 'failed') return command
    await new Promise((r) => setTimeout(r, 2_000))
  }
  throw new Error('El dispositivo no respondió en 30 segundos')
}
